export const THEMES = {
  LIGHT: 'LIGHT',
  ONE_DARK: 'ONE_DARK',
  UNICORN: 'UNICORN'
};

// TODO antigua regex CL
// /^(?:[A-Z]{2}[0-9]{4}|[A-Z]{4}[0-9]{2}|[A-Z]{3}[0-9]{2}|[A-Z]{2}[0-9]{3}|[A-Z]{3}[0-9]{3})$/,

export const licenseRegex: any = {
  cl:  /^[a-zA-Z0-9]{1,8}$/, 
  co: /(?:[A-Z]{3}[0-9]{3}|[A-Z]{2}[0-9]{4}|[A-Z]{1}[0-9]{4}|[A-Z]{1}[0-9]{5}|[A-Z]{2,3}[0-9]{2}[A-Z])$/,
  pe: /^[a-zA-Z0-9]{1,8}$/
};
